import clsx from "clsx";
import { GatewayEnum } from "../../enums";

type Props = {
  isChecked?: boolean;
  handlePaymentModeChange: (gateway_id: GatewayEnum, mode: string) => void;
};

const PayCash: React.FC<Props> = ({ isChecked, handlePaymentModeChange }) => {
  return (
    <>
      <div
        className={clsx(
          "choose_payment_method_colm card",
          isChecked && "payment-method-active",
        )}
      >
        <div className="card_viza card_viza2 border-bottom-0">
          <label>
            <span>
              <input
                type="radio"
                id="pay_with_cash"
                name="payment_mode"
                value={GatewayEnum.CASH}
                checked={isChecked}
                onChange={() =>
                  handlePaymentModeChange(GatewayEnum.CASH, "cash")
                }
              />{" "}
              Pay Cash
            </span>
          </label>
        </div>
      </div>
    </>
  );
};

export default PayCash;
